<template>
  <div ref="codemirror"></div>
</template>

<script>
  import CodeMirror from 'codemirror'
  import 'codemirror/lib/codemirror.css'
  import 'codemirror/theme/seti.css'
  import 'codemirror/theme/eclipse.css'
  import 'codemirror/mode/htmlmixed/htmlmixed.js'
  import 'codemirror/mode/css/css.js'
  export default {
    props: {
      value: {
        required: true
      },
      mode: {
        type:String,
        required: false,
        default: 'htmlmixed'
      },
      theme: {
        type:String,
        required: false,
        default: 'seti'
      },
    },
    data() {
      return {
        editor: null
      }
    },
    mounted() {
      this.editor = new CodeMirror(this.$refs.codemirror, {
        lineNumbers: true,
        tabSize: 2,
        value: this.value,
        mode: this.mode,
        theme: this.theme
      })
      this.editor.on('changes', () => this.$emit('input', this.editor.getValue()))
    },
  }
</script>